<template>
  <div class="container">
    <el-container>
      <!-- 左 -->
      <el-aside style="width: auto" class="aside-style">
        <el-menu :default-active="this.$store.state.sidePath" router class="el-menu-vertical-demo"
          @select="handleSelectMenu" @open="handleOpen" @close="handleClose">
          <router-link class="logo-box" to="/">
            <i class="logo"></i>
            <span class="title">Yedeer</span>
          </router-link>
          <!--  -->
          <el-menu-item index="/xqoverview/index">
            <i class="el-icon-menu"></i>
            <span slot="title">{{ languageDataObj.overview[language] }}</span>
          </el-menu-item>

          <el-menu-item index="/xqbasic/index">
            <i class="el-icon-s-order"></i>
            <span slot="title">{{ languageDataObj.basic[language] }}</span>
          </el-menu-item>
          <el-submenu index="/xqpositionmanagement">
            <template slot="title">
              <i class="el-icon-s-grid icon"></i>
              <span slot="title" class="title">{{
                languageDataObj.project[language]
              }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item style="padding-left: 55px" index="/xqpositionmanagement/index">{{
                languageDataObj.projectPost[language]
                }}</el-menu-item>
              <el-menu-item style="padding-left: 55px" index="/xqpositionmanagement/resumeDelivery">{{
                languageDataObj.delivery[language] }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="/xqpeoplemanagement">
            <template slot="title">
              <i class="el-icon-s-custom icon"></i>
              <span slot="title" class="title">{{
                languageDataObj.people[language]
              }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item style="padding-left: 55px" index="/xqpeoplemanagement/index">{{
                languageDataObj.people[language]
                }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="/xqoffermanagement">
            <template slot="title">
              <i class="el-icon-s-claim icon"></i>
              <span slot="title" class="title">{{
                languageDataObj.offer[language]
              }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item style="padding-left: 55px" index="/xqoffermanagement/index">{{
                languageDataObj.offerList[language]
                }}</el-menu-item>
              <el-menu-item style="padding-left: 55px" index="/xqappealmanagement/index">{{
                languageDataObj.Appeal[language]
                }}</el-menu-item>
              <el-menu-item style="padding-left: 55px" index="/xqevaluateManagement/index">{{
                languageDataObj.evaluate[language]
                }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item index="/xqonlinecommunication/index">
            <i class="el-icon-s-comment"></i>
            <span slot="title">{{ languageDataObj.online[language] }}</span>
          </el-menu-item>
          <!-- 消息管理 -->
          <el-menu-item index="/xqmessagecenter/xqmessagefeedback">
            <!-- <el-menu-item> -->
            <i class="el-icon-message-solid icon"></i>
            <span slot="title">{{
              languageDataObj.messagefeedback[language]
            }}</span>
          </el-menu-item>
          <el-menu-item index="/xqsetting/index">
            <i class="el-icon-s-tools"></i>
            <span slot="title">{{ languageDataObj.setting[language] }}</span>
          </el-menu-item>
          <!-- <el-menu-item index="3" disabled>
                    <i class="el-icon-document"></i>
                    <span slot="title">导航三</span>
                </el-menu-item>
                <el-menu-item index="4">
                    <i class="el-icon-setting"></i>
                    <span slot="title">导航四</span>
                </el-menu-item> -->
        </el-menu>
      </el-aside>
      <!-- 右 -->
      <el-container>
        <!-- 顶部 -->
        <el-header class="header-box">
          <div class="wrapper">
            <el-menu class="el-menu-demo menu-style" mode="horizontal" text-color="">
              <!-- <div class="iconbox">
                            <el-badge :value="0" class="item">
                                <el-button size="small" class="el-icon-message-solid"></el-button>
                            </el-badge>
                        </div> -->
              <div @click="handleToOnline" class="icon-message">
                <el-badge class="item" v-if="messageNum == 0">
                  <i class="el-icon-s-comment icon"></i>
                </el-badge>
                <el-badge class="item" :value="messageNum" v-if="messageNum != 0">
                  <i class="el-icon-s-comment icon"></i>
                </el-badge>
              </div>
              <div>
                <el-button class="change-type" @click="handleClickChangeType(0)" icon="el-icon-sort">{{
                  languageDataObj.changetype[language] }}</el-button>
              </div>
              <div class="box-select">
                <el-select v-model="languageType" @change="handleChangeLanguageType">
                  <el-option v-for="item in optionsLanguage" :key="item.value" :label="item.label" :title="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <el-menu-item class="avatar-style" index="2">
                <div>
                  <el-avatar size="medium" :src="'/api' + login.avatar"></el-avatar>
                  <!-- <img :src="'/api'+login.avatar" alt=""> -->
                </div>
              </el-menu-item>
              <el-submenu index="3">
                <template slot="title">
                  <span class="username-style" v-if="
                    user.sysUser != null &&
                    user.sysUser.userName != null &&
                    user.sysUser.userName != undefined &&
                    user.sysUser.userName != ''
                  ">{{ user.sysUser.userName }}</span>
                  <!-- clientCurrentAccount  v-if="user.sysUser == null || user.sysUser.userName == null || user.sysUser.userName == undefined || user.sysUser.userName == ''" -->
                  <span class="username-style" v-else>{{
                    login.clientCurrentAccount
                  }}</span>
                </template>
                <el-menu-item index="3-1">
                  <p @click="handleLogout">
                    {{ languageDataObj.logout[language] }}
                  </p>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </div>
        </el-header>
        <!-- 内容区域 -->
        <el-main class="content-box">
          <router-view></router-view>
        </el-main>
      </el-container>

      <div class="requirementButton">
        <!-- 客服按钮 -->
        <el-tooltip class="item" effect="dark" content="联系客服" placement="left">
          <div :class="[
            'meun-switch animated Flex-row',
            uploadflag ? 'active rubberBand off' : 'leave jello'
          ]" @mouseleave="uploadleave" @mouseenter="uploadenter" @click.stop="relationService"
            style="border-radius: 50%">
            <!-- <img src="../../assets/images/projectInfoTypeYY.png" /> -->
            <div style="display: flex; flex-direction: column; align-items: center">
              <!-- <div class="icon-message" style="border-radius: 50%">
                <svg
                  t="1691114609229"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2234"
                  width="200"
                  height="200"
                >
                  <path
                    d="M515.53 770.231c4.367 0 8.813-0.267 13.285-0.8 42.89-5.147 79.31-35.125 92.754-76.438 1.013-3.093-0.452-6.4-3.407-7.76-2.929-1.36-6.47-0.187-8.12 2.586-0.16 0.267-17.199 27.791-83.543 36.752-9.93 1.334-19.594 2.028-28.753 2.028-46.483-0.027-67.196-17.55-67.382-17.71-2.343-2.08-5.91-2.133-8.306-0.106-2.423 2.027-2.982 5.547-1.332 8.242 20.234 32.804 56.547 53.206 94.804 53.206z m356.723-411.153c-0.586 0-1.119 0.107-1.677 0.107-38.87-168.291-187.4-293.83-365.481-293.83-182.98 0-334.917 132.474-368.596 307.725-32.746 5.894-57.666 34.672-57.666 69.477v139.301c0 39.045 31.31 70.703 69.966 70.703 21.805 0 41.053-10.294 53.859-26.11 30.934 81.822 93.922 147.803 173.627 182.61 0.191-0.416 1.7-3.349 3.514-5.686 1.258-1.62 2.66-2.952 3.868-2.952 1.252 0 2.397 0.453 3.381 1.147-18.45-13.736-85.087-84.333-99.516-182.853-6.337-43.367 26.143-85.933 63.975-92.974 60.727-11.309 121.135-24.19 181.862-35.285 38.603-7.041 64.987-28.217 81.12-63.475 3.78-8.242 9.239-24.91 11.742-48.94 0.665-3.574 3.593-6.322 7.348-6.322 2.503 0 4.633 1.28 6.044 3.12l1.677-1.04c23.934 34.752 71.403 111.696 78.218 192.828 7.828 92.76 3.461 156.29-67.542 221.286a3 3 0 0 1-0.293 0.267 5.821 5.821 0 0 0-1.57 3.974c0 2 1.065 3.707 2.609 4.747 0.585 0.24 1.172 0.56 1.757 0.8 0.479 0.106 0.931 0.267 1.411 0.267s0.906-0.16 1.331-0.267c1.013-0.533 1.97-1.147 2.956-1.68 71.802-39.553 126.885-105.616 152.336-185.067 10.303 15.308 26.436 26.323 45.18 30.164-30.058 136.713-151.991 222.272-303.05 235.26-9.053-22.456-31.336-38.405-57.507-38.405-34.183 0-61.898 27.07-61.898 60.436s27.714 60.408 61.898 60.408c27.555 0 50.638-17.709 58.651-42.032 174.86-14.216 315.03-118.15 344.29-279.64 25.85-10.803 44.007-36.166 44.007-65.77V430.421c-0.002-39.392-32.164-71.344-71.831-71.344z m-64.508 40.486c-45.605-123.537-163.785-211.79-302.81-211.79-138.44 0-256.193 87.506-302.224 210.243-2.29-2.8-4.979-5.2-7.615-7.628 26.064-149.568 154.787-263.291 309.999-263.291 154.467 0 282.79 112.602 309.705 261.131-2.662 3.574-5.112 7.309-7.055 11.335z m-431.453 409.5l-0.008-0.003c-0.029 0.064-0.03 0.072 0.008 0.003z"
                    fill="#1296db"
                    p-id="2235"
                  ></path>
                </svg>
              </div> -->
              <div class="icon-message2">
                <img class="icon" src="@/assets/iconFontSvg/kefu.svg" style="border-radius: 50%" />
              </div>
            </div>
          </div>
        </el-tooltip>
        <!-- 小程序按钮 -->
        <el-tooltip class="item" placement="left">
          <template #content>
            <div style="text-align: center; margin-bottom: 5px">微信小程序</div>
            <img src="@/assets/images/xiaochengxu.jpg" style="width: 100px; height: 100px" />
          </template>
          <div :class="[
            'meun-switch2 animated Flex-row',
            uploadflag ? 'active rubberBand off' : 'leave jello'
          ]" @mouseleave="uploadleave" @mouseenter="uploadenter" style="border-radius: 50%">
            <!-- <img src="../../assets/images/projectInfoTypeYY.png" /> -->
            <div style="display: flex; flex-direction: column; align-items: center">
              <div class="icon-message2">
                <img class="icon" src="@/assets/iconFontSvg/xiaochengxu.svg" style="border-radius: 50%" />
              </div>
            </div>
          </div>
        </el-tooltip>
        <!-- 公众号按钮 -->
        <el-tooltip class="item" placement="left">
          <template #content>
            <div style="text-align: center; margin-bottom: 5px">微信公众号</div>
            <img src="@/assets/images/gongzhonghao.jpg" style="width: 100px; height: 100px" />
          </template>
          <div :class="[
            'meun-switch3 animated Flex-row',
            uploadflag ? 'active rubberBand off' : 'leave jello'
          ]" @mouseleave="uploadleave" @mouseenter="uploadenter" style="border-radius: 50%">
            <!-- <img src="../../assets/images/projectInfoTypeYY.png" /> -->
            <div style="display: flex; flex-direction: column; align-items: center">
              <div class="icon-message3">
                <img class="icon" src="@/assets/iconFontSvg/weixingongzhonghao.svg" style="border-radius: 50%" />
              </div>
            </div>
          </div>
        </el-tooltip>
      </div>
    </el-container>
  </div>
</template>

<script>
import mixin from '@/mixin/mixin'
import { LiaoTian, XQbasic, Admin } from '@/api'
import language from '@/utils/language'
export default {
  name: 'LayoutComponent',
  mixins: [mixin],
  data() {
    var websocket = null //用于消息推送
    var supConversationId = null //会话id
    var websocketHH
    return {
      // messageNum:0,
      // 是否折叠左侧菜单
      // isCollapse: false,
      //wsurl: 'ws://192.168.0.50:8081/socket/', //路由测试
       wsurl: 'wss://www.yedeer.com/besesunNew/socket/', //路由--服务器
      login: {},
      user: {},
      // language
      languageDataObj: null,
      optionsLanguage: [],
      languageType: 1,
      // 客服悬浮按钮
      uploadShow: false,
      uploadflag: true
    }
  },
  created() {
    //需求的顶部信息
    this.optionsLanguage = this.$store.state.optionsLanguageList
    this.languageType = this.$store.state.languageType
    // 获取浏览器语言类型
    this.backLanguageText('XQLayout')
    this.login = this.$cookies.get('loginUser')
    this.user = this.$store.state.user
    this.getOverviewData()
    this.openHHLink()
  },
  watch: {
    // 监听语言变化,并进行回调
    language: function (val, oldVal) {
      this.backLanguageText('XQLayout')
    }
  },
  computed: {
    // 是否折叠左侧菜单--获取仓库数据,监听
    // isCollapse(){
    //     return this.$store.getters.showAside
    // },
    // 计算监听数据
    language() {
      return this.$store.state.languageType
    },
    messageNum() {
      return this.$store.state.messageNum
    }
  },
  methods: {
    // 打开新页面，联系客服
    relationService() {
      window.open(
        'http://www.yedeer.com/xqrelationservice?userId=' +
          this.login.userId +
          '&usertype=1'
      )
      // window.open(
      //   'http://localhost:8080/xqrelationservice?userId=' +
      //   this.login.userId +
      //   '&usertype=1'
      // )
    },
    // 客服悬浮按钮
    uploadenter() {
      this.uploadflag = true
    },
    uploadleave() {
      this.uploadflag = false
    },
    uploadanimated() {
      setTimeout(() => {
        this.uploadShow = true
        setTimeout(() => {
          this.uploadleave()
        }, 1000)
      }, 1000)
    },
    // 切换选择语种显示
    handleChangeLanguageType(val) {
      this.$store.commit('languageTypeChange', val)
    },
    // 点击切换当前系统状态
    async handleClickChangeType(port) {
      //   console.log('login*******',this.login)
      let back = await Admin.switchIdentity({
        loginName: this.login.clientCurrentAccount,
        port: port
      })
      if (back.code == 0) {
        let user = JSON.stringify(back.data) //转换数据为json字符串
        window.localStorage.setItem('token', back.data.token) //存储token
        window.sessionStorage.setItem('loginUser', user) //存储登录用户信息
        this.$cookies.set('loginUser', user)
        // 缓存到仓库
        this.$store.commit('loginUser', user)

        this.$message.success(this.languageDataObj.login[this.language])

        if (back.data.port == 0) {
          this.$router.push('/overview/index')
        } else {
          this.$router.push('/xqoverview/index')
        }
      } else {
        this.$message.error(back.msg)
      }
    },
    // 点击跳转聊天
    handleToOnline() {
      this.$router.push({ path: '/xqonlinecommunication/index' })
    },
    // 点击退出登录
    handleLogout() {
      // console.log('11111退出登录')
      this.handleLoginOut()
    },
    handleLoginOut() {
      let _this = this
      this.$confirm(this.languageDataObj.confirmloginout[this.language], {
        confirmButtonText: this.languageDataObj.yes[this.language],
        cancelButtonText: this.languageDataObj.no[this.language],
        type: 'warning'
      }).then(async () => {
        let { msg, code } = await Admin.loginOut({
          supUserId: this.login.userId
        })
        if (code === 0) {
          this.$message.success(
            this.languageDataObj.loginoutsucess[this.language]
          )
          window.localStorage.removeItem('token')
          setTimeout(function () {
            _this.$router.replace({ path: '/login' })
          })
        } else {
          this.$message.error(this.languageDataObj.loginouterror[this.language])
        }
      })
    },
    async getOverviewData() {
      let back = await XQbasic.getOverviewData({ sysUserId: this.login.userId })
      if (back.code == 0) {
        this.dataObj = back.data
        this.$store.commit('userMu', back.data)
      }
    },
    handleSelect() {
      let _this = this
      this.$confirm(_this.languageDataObj.confirmloginout[language], {
        cancelButtonText: _this.languageDataObj.no[language],
        confirmButtonText: _this.languageDataObj.yes[language],
        type: 'warning'
      }).then(async () => {
        let { msg, code } = await Admin.loginOut({
          supUserId: this.login.userId
        })
        if (code == 0) {
          this.$message.success(
            this.languageDataObj.loginoutsucess[this.language]
          )
          window.localStorage.removeItem('token')
          this.$router.replace({ path: '/login' })
        } else {
          this.$message.error(
            this.languageDataObj.loginoutsucess[this.language]
          )
        }
      })
    },
    // 开启自己的会话链接
    openHHLink() {
      // 关闭之前的连接
      if (this.websocketHH) {
        this.websocketHH.close();
      }
      this.websocketHH = new WebSocket(this.wsurl + '' + this.login.userId + '_' + this.login.loginName)
      let _this = this
      this.websocketHH.onmessage = function (event) {
        _this.getXQUnreadmessage()
      }
      this.getXQUnreadmessage()
    },
    async getXQUnreadmessage() {
      let back = await LiaoTian.getXQUnreadmessage({
        userId: this.login.userId,
        loginName: this.login.loginName,
        port: "1"
      })
      this.$store.commit('messageNumChange', back)
    },
    // // 点击切换折叠状态 --  修改仓库
    // handleChangecollage(){
    //     // 获取当前折叠状态取反
    //     let status = this.isCollapse?false:true;
    //     // 修改仓库
    //     this.$store.commit("changeShowAside", status);
    // },
    // 切换选择的页面侧边栏--修改仓库
    handleSelectMenu(key, keyPath) {
      this.$store.commit('Set_sidebar', key)
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    }
  }
}
</script>

<style lang="less" scoped>
// 引入阿里图标库css样式
@import (css) '@/assets/aliIcon/iconfont.css';

* {
  text-decoration: none;
}

// 侧边悬浮按钮样式
.off {
  -webkit-animation: 1s seconddiv;
  background: transparent;
}

@keyframes seconddiv {
  0% {
    transform: scale(1.4, 1.4);
  }

  10% {
    transform: scale(1, 1);
  }

  25% {
    transform: scale(1.2, 1.2);
  }

  50% {
    transform: scale(1, 1);
  }

  70% {
    transform: scale(1.2, 1.2);
  }

  100% {
    transform: scale(1, 1);
  }
}

.icon-message {
  margin-right: 8px;
  width: 42px;
  height: 42px;
  display: block;
  background: #f4f5f6;
  // background-color: #000;
  border-radius: 14px;
  line-height: 42px;
  transition: all 0.3s;

  .icon {
    color: #909399;
    font-size: 18px;
  }

  &:hover {
    background: #bfbfbf;

    .icon {
      color: #fff;
    }
  }
}

.requirementButton {
  position: fixed;
  top: 500px;
  right: 10px;
  width: 50px;
  height: 175px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 5px;

  .meun-switch {
    // left: 0px;
    z-index: 2001;
    cursor: pointer;
    // width: 150px;
    // height: 150px;
    padding: 5px;
    transition: all 0.25s;

    // &.leave {
    //     left: -65px;
    // }

    // &.active {
    //     left: 0;
    // }

    &:hover {
      transform: scale(1.02);
    }

    img {
      width: auto;
      height: auto;
    }
  }

  .meun-switch2 {
    z-index: 2001;
    cursor: pointer;
    // width: 150px;
    // height: 150px;
    padding: 5px;
    transition: all 0.25s;
    // &.leave {
    //     left: -65px;
    // }

    // &.active {
    //     left: 0;
    // }

    &:hover {
      transform: scale(1.02);
    }

    img {
      width: auto;
      height: auto;
    }
  }

  .meun-switch3 {
    z-index: 2001;
    cursor: pointer;
    // width: 150px;
    // height: 150px;
    padding: 5px;
    transition: all 0.25s;
    // &.leave {
    //     left: -65px;
    // }

    // &.active {
    //     left: 0;
    // }

    &:hover {
      transform: scale(1.02);
    }

    img {
      width: auto;
      height: auto;
    }
  }

  .icon-message2 {
    position: relative;
    z-index: 99;
    margin: 0 0.5rem;
    width: 50px;
    height: 50px;
    display: block;
    // background: #f4f5f6;
    // border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    .icon {
      width: 40px;
      height: 40px;
      border: none;

      &:hover {
        background-color: #bfbfbf;
      }
    }

    // &:hover {
    //   background-color: #bfbfbf;
    //   .icon {
    //     background-color: #bfbfbf;
    //   }
    // }
  }

  .icon-message3 {
    position: relative;
    z-index: 99;
    margin: 0 0.5rem;
    width: 50px;
    height: 50px;
    display: block;
    // background: #f4f5f6;
    // border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    .icon {
      width: 35px;
      height: 35px;
      border: none;

      // background-color: #d2e7f9;
      &:hover {
        background-color: #bfbfbf;
        cursor: pointer;
      }
    }

    // &:hover {
    //   background-color: #bfbfbf;
    //   .icon {
    //     background-color: #bfbfbf;
    //   }
    // }
  }
}

// 主题内容样式
.container {
  .logo-box {
    display: flex;
    // justify-content: center;
    // background-color: #c00;
    align-items: center;
    padding: 1.38rem 2rem;
    margin-bottom: 1.5rem;
    cursor: pointer;

    .logo {
      width: 2rem;
      height: 2rem;
      display: inline-block;
      margin-right: 0.75rem;
      background: url(@/assets/logo.png) no-repeat center center/cover;
    }

    .title {
      font-family: ArialRoundedmt;
      font-size: 1.37rem;
      color: #000000;
    }
  }

  // 折叠样式
  .el-menu-vertical-demo.el-menu--collapse.el-menu {
    width: 80px;
    min-height: 100vh;
    background-color: #fff;

    .logo-box {
      padding: 1.38rem 1rem;
      justify-content: center;

      .title {
        display: none;
      }
    }
  }

  // 头部样式
  .header-box {
    background-color: #fff;
    min-height: 5rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .wrapper {
      .el-menu-demo.menu-style {
        display: flex;
        align-items: center;

        .box-select {
          // margin-right: 1rem;
          width: 6.5rem;
        }

        .iconbox {
          position: relative;
          z-index: 99;

          .item {
            width: 3rem;
            height: 3rem;
            background-color: #f6f6f6;
            border-radius: 15px;
            text-align: center;
            line-height: 3rem;

            .el-button--small {
              border: none;
              background-color: transparent;
              color: #a5a9b5;

              &:hover {
                color: #000;
              }
            }

            .iconbtn {
              font-size: 18px;
            }
          }
        }

        .username-style {
          color: #000;
          font-size: 0.88rem;
          font-family: PingFangSC-Medium;
        }
      }

      .el-menu.el-menu--horizontal {
        border: none;
        background-color: transparent;
      }
    }
  }
}

.avatar-style {
  position: relative;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 100vh;
  width: 13.75rem;
  // height: 56.25rem;
  background: #ffffff;
}

/deep/ .el-submenu {
  .el-submenu__title {
    text-align: left;
    font-size: 0.88rem;
  }
}

/deep/ .el-avatar>img {
  background-color: #fff;
}

.iconfont {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}

.aside-style {
  background-color: #fff;
}

.aside-style .el-menu-item {
  font-size: 0.88rem;
  color: rgba(0, 0, 0, 0.8);
  text-align: left;
  font-weight: 600;

  i {
    font-size: 24px;
  }
}

.aside-style .el-submenu {
  .el-submenu__title {}

  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  text-align: left;
  font-weight: 600;

  i {
    font-size: 24px;
  }

  .el-menu {
    .el-menu-item {
      font-size: 12px;
      font-weight: 500;
    }
  }
}

.aside-style .el-menu-item.is-active {
  color: rgb(60, 154, 255);
  font-weight: 600;
  // font-size: 0.75rem;
}

.header-box .el-menu--horizontal>.el-menu-item.is-active,
.header-box .el-menu--horizontal>.el-menu-item {
  border: none;
  color: #a5a9b5;
}

.content-box.el-main {
  padding: 0 20px 20px 0;
}

/deep/ .menu-style {
  .el-select {
    .el-input__inner {
      border-radius: 0.88rem;
      background-color: #f4f5f6;
    }
  }
}

/deep/ .el-badge__content.is-fixed {
  right: 0;
}

/deep/ .change-type {
  padding: 5px 5px;
  height: 40px;
  box-sizing: border-box;
  border-radius: 0.88rem;
  margin-right: 5px;
  color: #606266;
  background-color: #f4f5f6;
  border-color: #dedede;

  &:hover {
    background-color: #f4f5f6;
    color: #606266;
    border-color: #c5c6c9;
  }

  .el-icon-sort {
    transform: rotate(90deg);
  }
}
</style>
